import useLocalStorage from '@/hooks/useLocalStorage'
import { useRootOrganization } from '../organizations/RootOrganizationProvider'

export default function useRecentDocumentIds() {
  const { rootOrganization } = useRootOrganization()

  return useLocalStorage<string[]>(
    `recent-documents-${rootOrganization.id}`,
    [] as string[],
  )
}
